/// <amd-module name="Artifacts/Pypi/commands/Restore" />
import { PypiActions } from "Artifacts/Pypi/redux";
import { getRestoreCommandCreator } from "Artifacts/Root/protocols/Commands";

export const createRestoreCommand = getRestoreCommandCreator(PypiActions.restore);
